export enum ManagedPostType {
  Feed = 'FEED',
  Story = 'STORY',
  Reel = 'REEL',
}
